// extracted by mini-css-extract-plugin
export var backupIcon = "_on-1";
export var image = "_on-0";